export default "__VITE_ASSET__22s9s6I___"